import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import axios from "axios";

function SewadarLeave() {
  const [sewadar, setSewadar] = useState("");
  const [loading, setLoading] = useState(false);

  const [sewadarAttendance, setSewadarAttendance] = useState({});
  const history = useHistory();
  const [sewadarDetails, setSewadarDetails] = useState({});
  const [allowed, setAllowed] = useState(false);
  const [items, setItems] = useState([]);
  const search = useRef(null);
  const [leaveReason, setLeaveReason] = useState("");
  const [leaveStartDate, setLeaveStartDate] = useState("");
  const [leaveEndDate, setLeaveEndDate] = useState("");
  const [autoCompleteKey, setAutoCompleteKey] = useState(0);

  const roleNames = {
    CR: "Coordinator",
    ZI: "Zone Incharge",
    GI: "Group Incharge",
    NS: "Sewadar",
  };

  function markLeave() {
    if (sewadar) {
      setLoading(true);
      axios
        .post(
          "https://a9s48sduha.execute-api.ap-northeast-1.amazonaws.com/v1/weekly/sewadar/markleave",
          {
            sewadarBadge: sewadar,
            userId: JSON.parse(localStorage.getItem("userdata")).username,
            startDate: leaveStartDate,
            endDate: leaveEndDate,
            leaveReason: leaveReason,
          }
        )
        .then(function (response) {
          if (response.data.status === "success") {
            alert("Leave marked successfully");
            setSewadar("");
            setLeaveStartDate("");
            setLeaveEndDate("");
            setLeaveReason("");
            setAutoCompleteKey(autoCompleteKey + 1);
          } else if (response.data.status === "failure") {
            alert(JSON.parse(response.data.body).message);
          }
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoading(false);
        });
      setLoading(false);
    }
  }
  useEffect(() => {
    if (localStorage.getItem("userdata")) {
      var userdata = JSON.parse(localStorage.getItem("userdata"));
      if (["ADMIN", "OFFICE"].includes(userdata.role)) {
        setAllowed(true);
        axios
          .post(
            "https://a9s48sduha.execute-api.ap-northeast-1.amazonaws.com/v1/weekly/sewadar/allgroupsewadar"
          )
          .then(function (response) {
            console.log(response.data.body);
            if (response.data.status === "success") {
              setItems(JSON.parse(response.data.body).sewadarList);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        setAllowed(false);
      }
    } else {
      history.push("/");
    }
  }, []);

  useEffect(() => {}, [sewadar]);

  // useEffect(() => {
  //   if (
  //     ["ADMIN", "OFFICE"].includes(
  //       JSON.parse(localStorage.getItem("userdata")).role
  //     )
  //   ) {
  //     setAllowed(true);
  //     document.getElementById("sewadarBadge").focus();
  //   } else {
  //     setAllowed(false);
  //   }
  // }, []);
  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    console.log(string, results);
  };

  const handleOnHover = (result) => {
    // the item hovered
    console.log(result);
  };

  const handleOnSelect = (item) => {
    // the item selected
    console.log(item);
    setSewadarDetails(item);
    setSewadar(item.id);
  };

  const handleOnFocus = () => {
    console.log("Focused");
  };

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>
          Badge: {item.id}
        </span>
        <span style={{ display: "block", textAlign: "left" }}>
          Name: {item.name}
        </span>
      </>
    );
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-5 items-center">
        <div className="page-title">Mark Leave</div>
        <div className="col-span-12 md:col-span-12">
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <ReactSearchAutocomplete
              key={autoCompleteKey}
              ref={search}
              items={items}
              onSearch={handleOnSearch}
              onHover={handleOnHover}
              onSelect={handleOnSelect}
              onFocus={handleOnFocus}
              autoFocus
              formatResult={formatResult}
              placeholder="Search Sewadar"
              fuseOptions={{
                keys: ["name"],
                threshold: 0.1,
              }}
            />
          </form>
        </div>
        <div className="col-span-12 md:col-span-12">
          <label htmlFor="leaveReason" className="form-label">
            Leave Reason
          </label>
          <input
            type="text"
            name="leaveReason"
            id="leaveReason"
            value={leaveReason}
            onChange={(e) => {
              setLeaveReason(e.target.value);
            }}
            className="form-input"
          />
        </div>
        <div className="col-span-12 md:col-span-6">
          <label htmlFor="leaveStartDate" className="form-label">
            Start Date
          </label>
          <input
            type="date"
            name="leaveStartDate"
            id="leaveStartDate"
            value={leaveStartDate}
            onChange={(e) => {
              setLeaveStartDate(e.target.value);
            }}
            className="form-input"
          />
        </div>

        <div className="col-span-12 md:col-span-6">
          <label htmlFor="leaveEndDate" className="form-label">
            End Date
          </label>
          <input
            type="date"
            name="leaveEndDate"
            id="leaveEndDate"
            value={leaveEndDate}
            onChange={(e) => {
              setLeaveEndDate(e.target.value);
            }}
            className="form-input"
          />
        </div>

        <div className="col-span-12 md:col-span-12">
          {!loading ? (
            <input
              type="button"
              value="Mark Leave"
              onClick={() => markLeave()}
              className="btn-primary"
            />
          ) : (
            <img
              src="/images/loading.gif"
              alt="loading"
              className="w-10 h-10 mx-auto"
            />
          )}
        </div>

        {Object.keys(sewadarAttendance).length > 0 && (
          <div className="col-span-12">
            <div className="grid grid-cols-12 gap-5">
              <div className="col-span-12 md:col-span-2">Sewadar Name</div>
              <div className="col-span-12 md:col-span-10 text-2xl font-bold text-green-600">
                {sewadarAttendance.sewadarName}
              </div>
              <div className="col-span-12 md:col-span-2">Sewadar Badge</div>
              <div className="col-span-12 md:col-span-10 text-2xl font-bold text-green-600">
                {sewadarAttendance.sewadarBadge}
              </div>
              <div className="col-span-12 md:col-span-2">Sewadar Point</div>
              <div className="col-span-12 md:col-span-10 text-2xl font-bold text-green-600">
                {sewadarAttendance.pointName}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default SewadarLeave;
